import React from 'react';
import styles from './index.module.scss'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

const Gallery = (props) => {
  const {compData} = props;
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    speed: 600,
    autoplaySpeed: 6000,
    centerMode: true,
    cssEase: "linear",
    nextArrow: <NextArrow/>,
    prevArrow: <PrevArrow/>,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1.25,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false
            }
        },
        {
            breakpoint: 200,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false
            }
        }
    ]
  };

  function NextArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      ><FontAwesomeIcon icon={faAngleRight} /></div>
    );
  }
  
  function PrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      ><FontAwesomeIcon icon={faAngleLeft} /></div>
    );
  }

  return (
    <div className={styles.wrapper}>
        <Slider {...settings}>
            {compData?.gallery_thumb_01 && <div><img src={compData?.gallery_thumb_01} alt=""/></div>}
            {compData?.gallery_thumb_02 && <div><img src={compData?.gallery_thumb_02} alt=""/></div>}
            {compData?.gallery_thumb_03 && <div><img src={compData?.gallery_thumb_03} alt=""/></div>}
            {compData?.gallery_thumb_04 && <div><img src={compData?.gallery_thumb_04} alt=""/></div>}
            {compData?.gallery_thumb_05 && <div><img src={compData?.gallery_thumb_05} alt=""/></div>}
            {compData?.gallery_thumb_06 && <div><img src={compData?.gallery_thumb_06} alt=""/></div>}
            {compData?.gallery_thumb_07 && <div><img src={compData?.gallery_thumb_07} alt=""/></div>}
            {compData?.gallery_thumb_08 && <div><img src={compData?.gallery_thumb_08} alt=""/></div>}
            {compData?.gallery_thumb_09 && <div><img src={compData?.gallery_thumb_09} alt=""/></div>}
            {compData?.gallery_thumb_10 && <div><img src={compData?.gallery_thumb_10} alt=""/></div>}
            {compData?.gallery_thumb_11 && <div><img src={compData?.gallery_thumb_11} alt=""/></div>}
            {compData?.gallery_thumb_12 && <div><img src={compData?.gallery_thumb_12} alt=""/></div>}
        </Slider>
      {/* <div className={styles.galleryWrapper}>
        {compData?.gallery_thumb_01 && <div><img src={compData?.gallery_thumb_01} alt=""/></div>}
        {compData?.gallery_thumb_02 && <div><img src={compData?.gallery_thumb_02} alt=""/></div>}
        {compData?.gallery_thumb_03 && <div><img src={compData?.gallery_thumb_03} alt=""/></div>}
        {compData?.gallery_thumb_04 && <div><img src={compData?.gallery_thumb_04} alt=""/></div>}
        {compData?.gallery_thumb_05 && <div><img src={compData?.gallery_thumb_05} alt=""/></div>}
        {compData?.gallery_thumb_06 && <div><img src={compData?.gallery_thumb_06} alt=""/></div>}
        {compData?.gallery_thumb_07 && <div><img src={compData?.gallery_thumb_07} alt=""/></div>}
        {compData?.gallery_thumb_08 && <div><img src={compData?.gallery_thumb_08} alt=""/></div>}
        {compData?.gallery_thumb_09 && <div><img src={compData?.gallery_thumb_09} alt=""/></div>}
        {compData?.gallery_thumb_10 && <div><img src={compData?.gallery_thumb_10} alt=""/></div>}
        {compData?.gallery_thumb_11 && <div><img src={compData?.gallery_thumb_11} alt=""/></div>}
        {compData?.gallery_thumb_12 && <div><img src={compData?.gallery_thumb_12} alt=""/></div>}
      </div> */}
    </div>
  );
};

export default Gallery;
